import type { Tomo } from '../types/content'

export const tomos: Tomo[] = [
  {
    id: 'Tomo I',
    title: 'Guerrilla en el Supermercado',
    category: 'Sistema de Compra',
    description:
      'La Fit-Tax, el CPGP, los 7 canales de compra, la Lista Maestra de 40 productos y el protocolo de compra semanal blindado.',
    saving: 'Ahorro: $148.000 ARS/mes',
    accent: 'bg-[#16a34a]',
    accentText: 'text-[#16a34a]',
  },
  {
    id: 'Tomo II',
    title: 'Meal Prep Blindado',
    category: 'Preparación Semanal',
    description:
      '21 comidas en 3 horas. Las 7 bases de cocción paralela, el sistema FIFO y el Calendario de Rotación de Sabores.',
    saving: 'Ahorro: $97.000 ARS/mes',
    accent: 'bg-[#334155]',
    accentText: 'text-[#334155]',
  },
  {
    id: 'Tomo III',
    title: 'Cocina de Supervivencia',
    category: 'Cocina de Emergencia',
    description:
      '21 recetas de 15 minutos. Las 5 salsas base, la alacena de emergencia de 15 ítems y el árbol de decisión anti-delivery.',
    saving: 'Ahorro: $48.000 ARS/mes',
    accent: 'bg-[#1d4ed8]',
    accentText: 'text-[#1d4ed8]',
  },
  {
    id: 'Tomo IV',
    title: 'Anabólicos Naturales Low-Cost',
    category: 'Nutrición Deportiva',
    description:
      'Síntesis proteica, umbral de leucina, distribución en 4 eventos y los 8 potenciadores naturales documentados.',
    saving: 'Ahorro: $52.000 ARS/mes',
    accent: 'bg-[#7c3aed]',
    accentText: 'text-[#7c3aed]',
  },
  {
    id: 'Tomo V',
    title: 'Detox de Azúcar en 7 Días',
    category: 'Reset Metabólico',
    description:
      'El reset del sistema dopaminérgico, el protocolo de 7 días, el mapa del azúcar oculta en 47 productos y la Regla 90/10 post-detox.',
    saving: 'Ahorro: $44.000 ARS/mes',
    accent: 'bg-[#dc2626]',
    accentText: 'text-[#dc2626]',
  },
  {
    id: 'Tomo VI',
    title: 'El Método de Escala Financiera',
    category: 'Escala Financiera',
    description:
      'La Pirámide de Reinversión de 4 capas, el biohacking de costo cero, los suplementos con ROI real y el stock anti-inflación.',
    saving: 'Multiplicador de todo el sistema',
    accent: 'bg-[#d97706]',
    accentText: 'text-[#d97706]',
  },
]

export const heroTomos: string[] = [
  'Tomo I — Guerrilla en el Supermercado',
  'Tomo II — Meal Prep Blindado',
  'Tomo III — Cocina de Supervivencia',
  'Tomo IV — Nutrición Deportiva Económica',
  'Tomo V — Detox de Azúcar en 7 Días',
  'Tomo VI — El Método de Escala Financiera',
]
